import React from 'react';
import { useTranslate } from '@tolgee/react';
import UpgradeRequiredTooltipWrapper from '../../../utils/billing/UpgradeRequiredTooltipWrapper';

interface BulkImportButtonProps {
  /** Not included in the plan: renders locked and opens nothing. */
  locked: boolean;
  onOpen: () => void;
}

/**
 * Entry point to the CSV importer, gated on the bulk_upload plan feature.
 *
 * Store-free by design: the gate and the action are props, so this renders in a
 * test without the whole creator slice — which is why it lives outside the bar.
 *
 * The button stays clickable while locked. UpgradeRequiredTooltipWrapper only
 * renders a hint; it never withholds the child's action, and a `disabled`
 * button emits no pointer events, so the hint would never open either. The
 * gate therefore has to sit on the handler.
 */
const BulkImportButton: React.FC<BulkImportButtonProps> = ({
  locked,
  onOpen
}) => {
  const { t } = useTranslate();

  return (
    <UpgradeRequiredTooltipWrapper show={locked}>
      <button
        className={`btn btn-white me-2 btn-sm d-flex justify-content-center align-items-center${
          locked ? ' text-muted' : ''
        }`}
        aria-disabled={locked}
        onClick={() => {
          if (locked) return;
          onOpen();
        }}
      >
        <i
          className={`me-1 fa-solid ${locked ? 'fa-lock' : 'fa-file-import'}`}
        ></i>
        <span>{t('lomavisCreator.buttonsBar.bulkImport')}</span>
      </button>
    </UpgradeRequiredTooltipWrapper>
  );
};

export default BulkImportButton;
